export const ERROR_SYSTEMCONNECT = '系統連線錯誤，請稍後再試，或聯繫系統管理員處理。';
export const ERROR_AUTH = '您無瀏覽權限，若有任何疑問請聯繫系統管理員處理。';
export const ERROR_CERTIFICATE = '登入憑證已過期，請重新登入。';
export const ERROR_EMPTY_ACCOUNTORPWD = '請輸入帳號與密碼。';
export const ERROR_ACCOUNTORPWD = '帳號或密碼錯誤，請重新輸入。';
export const ERROR_REPORT_NOT_FOUND = '此帳戶不存在，請重新確認';
export const ERROR_CUSTOM_EXPRESSION = '公式有誤，請重新確認。';
export const ERROR_CHECK_FORM = '表單資料有誤，請重新確認。';
export const ERROR_SYSTEM_PROCESSING = '系統處理中，請稍後再試。';

export const ERROR_DOWNLOAD_EXCEL = '選擇的範圍無資料，請重新確認';

export const SUCCESS_AI_BLOCKED_OPEN = 'AI 對話啟用成功';
export const SUCCESS_CHANGE_AI_CLOSE = 'AI 對話關閉成功';

export const SUCCESS_CPOY = "已複製內文到剪貼簿！";
export const ERROR_CPOY = "瀏覽器未支援此功能，請使用最新版本的瀏覽器，或手動複製。";

export const LOGOUT_SUCCESS = '您已成功登出';
export const CANCEL_REQUEST = 'cancelRequest';

export const ALERT_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error'
}
